module.exports = __webpack_public_path__ + "img/output-sun-pump.6ffd8f81.png";